var React = require('react');

function AngleUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.001 12.25c-.287 0-.571-.122-.769-.356L7.996 6.85l-4.228 5.034a1.005 1.005 0 0 1-1.409.127.99.99 0 0 1-.127-1.4L7.996 3.75l5.772 6.87a.99.99 0 0 1-.127 1.4c-.188.155-.414.23-.64.23"}));
}

AngleUp.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleUp;

AngleUp.default = AngleUp;
